import React, { useRef, useEffect, useState } from 'react'
import { DSIcon } from '../../common/atoms'

const SearchBar = ({ placeholder = '', handler = () => {}, inputRefStr = 'search-bar-xs', CloseIconHandler = () =>{}, searchIconClasses = 'left-4 top-5', clearIconClasses = 'right-4 top-4', classes = '', closeIcon = '' ,  inputClasses = 'p-4 pl-10 rounded-md', label = '', labelClasses = '' }) => {
  const searchRef = useRef(inputRefStr)
  const [value , setValue] = useState('')

  useEffect(() => {
    const onEnter = (event) => {
      const curElement = searchRef.current
      if (event.keyCode === 13 && document.activeElement === curElement) {
        const value = curElement.value
        handler(value)
      }
    }
    document.addEventListener('keyup', onEnter)

    return () => document.removeEventListener('keyup', onEnter)
  }, [handler])
      
  return (
    <div className={`relative ${classes}`}>
        { label && <label className={`mb-0 ${labelClasses}`}>{label}</label>}
        <input ref={searchRef} 
          placeholder={placeholder}
          value={value} 
          onChange={(e) => setValue(e.target.value)}
          className={`w-full border border-gray-250 text-[13px] font-medium text-gray-900 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 ${inputClasses}`} />
        <span className={`pointer-events-none absolute text-gray-500 ${searchIconClasses}`}>
          <DSIcon name='search' size={16} />
        </span>
        { value && 
          <button
            type='button'
            aria-label='Clear search'
            onClick={() => {
              setValue('')
              CloseIconHandler()
            }} 
            className={`absolute inline-flex h-8 w-8 items-center justify-center rounded-[10px] text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-900 ${clearIconClasses}`}
          >
            {closeIcon ? <img src={closeIcon} alt='clear-search' className='h-3 w-3' /> : <DSIcon name='close' size={14} />}
          </button> }
        </div>    
  )
}

export default SearchBar
